<template>
  <div :id="`${id}_wrap`" 
    :class="{
      'newline': newline,
      'checkbox-wrap': true, 
      'checkbox-wrap--state-disabled': disabled,
      'checkbox-wrap--label-right': labelRight,
    }">
    <input v-if="formInputName" type="hidden" :name="formInputName" :value="checked" />
    <label v-if="label && !labelRight" :id="`${id}_label`" class="label auto-width" :for="`${id}_button`">{{ label }}</label>
    <button :id="`${id}_button`" 
      :class="{ 
        checkbox: true, 
        'checkbox--state-checked': checked, 
        'checkbox--state-disabled': disabled, 
        'checkbox--state-error': error 
      }" 
      role="checkbox" 
      type="button"
      tabindex="0"
      :aria-checked="checked"       
      :aria-labelledby="`${id}_label`"
      :disabled="disabled"
      @click="onButtonClick">      
      <svgicon v-if="checked" class="checkbox__check" icon="glyph/16/check" width="16" height="16" ></svgicon>
    </button>
    <label v-if="label && labelRight" :id="`${id}_label`" class="label auto-width" :for="`${id}_button`">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: "CheckboxComponent",
  props: {
    id: String,
    value: Boolean,
    label: String, 
    name: String,
    error: Boolean,
    disabled: Boolean,
    newline: Boolean,
    labelRight: {
      type: Boolean,
      default: false,
    },
    // This is used if this component is used in a form outside of the legacy code
    formInputName: {
      type: String,
      default: "",
    },    
  },
  data() {
    return {
      checked: false
    }
  },
  created() {
    this.checked = this.value
  },
  watch: {
    value() {
      if ( this.checked !== this.value ) {
        this.checked = this.value
      }
    }
  },
  methods: {
    onButtonClick() {
      this.checked = !this.checked
      this.$emit("change", this.checked);
      this.$emit("input", this.checked);
    }
  }
}
</script>